import { Navigate, Route, RouteObject } from "react-router-dom";
import { Workflows } from "../work-flow/components/landing/workflow";
import CreateWorkflowPage from "./components/create/WorkflowStepper";
import { Details } from "./components/details/details";
import { WorkflowViewPage } from "./components/details/WorkFlowDetail";
import { WorkflowHistoryDetails } from "./components/history/details";
export interface WorkflowsSetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: WorkflowsSetupRoute[];
}
export const workflowsSetupRoutes: WorkflowsSetupRoute[] = [
  // {
  //   path: "/communication-hub",
  //   element: <Navigate to="/communication-hub/dashboard" replace />,
  // },
  // {
  //   path: "/communication-hub/workflows",
  //   element: <Workflows />,
  // },
  // {
  //   path: "/communication-hub/workflows/create",
  //   element: <CreateWorkflowPage />,
  // },
  // {
  //   path: "/communication-hub/workflows/view/:id",
  //   element: <WorkflowViewPage />, // Component that renders Details with mode="view"
  // },
  // {
  //   path: "/communication-hub/workflows/history/:runId",
  //   element: <WorkflowHistoryDetails />,
  // },
];
